// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"65df779d","327":"9720d76b","419":"d061a455","473":"756165a3","485":"6d63c69b","739":"05d64b4e","883":"2fffaabf","896":"91dc4c82","942":"da4bca52"}[chunkId] + ".chunk.js";
};